import { EntityMembersTaskEditor } from './EntityMembersTaskEditor'

export const EntityMembersFeatureMap = {
  Component: {
    traitId: 'eqipSigningAuthority' as const,
    TaskEditor: EntityMembersTaskEditor,
  },
  resourceType: 'workflow' as const,
}
